export default __webpack_public_path__ + "static/media/trades.276835f1.png";